export const OR = "or";
export const AND = "and";
export const NOT = "not";
